import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { buildNewMessageDraft, closeNewMessageDialog } from '../../store/actions/messages.actions';
import { MessageProviderSelectionComponent } from '../provider-selection/provider-selection.component';
import { TopicSelectionComponent } from '../topic-selection/topic-selection.component';

@Component({
  selector: 'app-new-message-dialog',
  imports: [MatDialogModule, MatButtonModule, MessageProviderSelectionComponent, TopicSelectionComponent],
  templateUrl: './new-message-dialog.component.html',
  styleUrl: './new-message-dialog.component.scss',
})
export class NewMessageDialogComponent {
  private store = inject(Store);

  currentStep: 1 | 2 = 1;
  providerUserId: string | null = null;
  messageTopicId: number | null = null;

  close() {
    this.store.dispatch(closeNewMessageDialog());
  }

  goBack() {
    this.providerUserId = null;
    this.currentStep = 1;
  }

  onSelection(value: string | number) {
    if (this.currentStep === 1) {
      this.providerUserId = value as string;
      this.currentStep++;
    } else {
      const messageTopicId = value as number;
      this.messageTopicId = messageTopicId;
      const providerUserId = this.providerUserId;
      if (providerUserId === null) return;
      this.store.dispatch(buildNewMessageDraft({ providerUserId, messageTopicId }));
    }
  }
}
